import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "./components/shared/Navbar";
import Footer from "./components/shared/Footer";
import CartDrawer from "./components/shared/CartDrawer";
import ScrollToTop from "./utils/ScrollToTop";
import StructuredData from "./components/shared/StructuredData";
import { CartDrawerProvider } from "./context/CartDrawerContext";

const App = () => {
  return (
    <CartDrawerProvider>
      <Router>
        <StructuredData />
        <ScrollToTop />
        <Navbar />
        <ToastContainer />
        <AppRoutes />
        <Footer />
        <CartDrawer />
      </Router>
    </CartDrawerProvider>
  );
};

export default App;
